// context/FidelityLevelContext.tsx
import React, { createContext, useContext, useState, useCallback } from "react";
import { EFidelityLevelMan, EFidelityLevelWoman, FidelityLevel, Gender } from "./models";
import { getFidelityLevel } from "../actions/fidelityLevel";

interface FidelityContextType {
  fidelityLevel: FidelityLevel;
  fetchFidelityLevel: () => Promise<void>;
}

const FidelityLevelContext = createContext<FidelityContextType | undefined>(undefined);

export const FidelityLevelProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [fidelityLevel, setFidelityLevel] = useState<FidelityLevel>({
        level: EFidelityLevelMan.PIONEER,
        gender: Gender.male
    });
    const fetchFidelityLevel = useCallback(async () => {
        try {
            const { level, gender } = await getFidelityLevel();
    
            const normalizedGender = gender.toLowerCase() as Gender;
    
            let parsedLevel: EFidelityLevelMan | EFidelityLevelWoman;
    
            if (normalizedGender === Gender.male && Object.values(EFidelityLevelMan).includes(level as EFidelityLevelMan)) {
                parsedLevel = level as EFidelityLevelMan;
            } else if (normalizedGender === Gender.female && Object.values(EFidelityLevelWoman).includes(level as EFidelityLevelWoman)) {
                parsedLevel = level as EFidelityLevelWoman;
            } else {
                // fallback se livello non valido
                parsedLevel = EFidelityLevelMan.PIONEER;
            }
    
            setFidelityLevel({
                gender: normalizedGender,
                level: parsedLevel
            });
    
        } catch (err) {
            console.error("Errore fetch fidelityLevel", err);
            setFidelityLevel({
                level: EFidelityLevelMan.PIONEER,
                gender: Gender.male
            }); // fallback
        }
    }, []);

    return (
        <FidelityLevelContext.Provider value={{ fidelityLevel, fetchFidelityLevel }}>
            {children}
        </FidelityLevelContext.Provider>
    );
};

export const useFidelityLevel = () => {
    const ctx = useContext(FidelityLevelContext);
    if (!ctx) throw new Error("useFidelityLevel must be used inside FidelityLevelProvider");
    return ctx;
};
